<template>
  <div class="discount-card-rule">
    <p class="discount-card-rule__level-title">Уровень {{ levelNumber }}</p>
    <div class="discount-card-rule__item">
      <price-input-rub
        v-model="amount"
        title="Сумма оплат"
        v-bind:disabled="disabled"
        v-bind:max-length="7"
        v-bind:violations="amountErrors"
        v-on:input="onInput"
      />
      <input-discount-in-percent
        v-model="percentage"
        title="Скидка"
        class="discount-card-rule__percentage-input"
        v-bind:disabled="disabled"
        v-bind:violations="percentageErrors"
        v-on:input="onInput"
      />
      <button
        class="discount-card-rule__button-close"
        type="button"
        v-bind:disabled="disabledDelete || disabled"
        v-on:click="onDelete"
      />
    </div>

  </div>
</template>

<script>
import { Level } from '@/mixins/loyaltySystemMixin';
import PriceInputRub from '@/components/PriceInputRub.vue';
import InputDiscountInPercent from '@/components/InputDiscountInPercent.vue';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.violations ? vm.violations[cause] : []
);

export default {
  /**
   * @description Уровень скидки
   */
  name: 'DiscountCardRule',
  components: {
    InputDiscountInPercent,
    PriceInputRub,
  },
  computed: {
    percentageErrors() {
      const eitherId = this.id.length > 0 ? this.id : this.tmpId;
      return resolveInputErrors(`percentage-${eitherId}`)(this);
    },
    amountErrors() {
      const eitherId = this.id.length > 0 ? this.id : this.tmpId;
      return resolveInputErrors(`amount-${eitherId}`)(this);
    },
  },
  data() {
    return {
      /**
       * @description Сумма
       * @type {number}
       */
      amount: this.value.amount,

      /**
       * @description Процент
       * @type {number}
       */
      percentage: this.value.percentage,

      /**
       * @description Идентификатор
       * @type {string}
       */
      id: this.value.id,

      /**
       * @description Временный Id
       * @type {string}
       */
      tmpId: this.value.tmpId,
    };
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.value.getId());
    },
    onInput() {
      const request = new Level(
        this.id,
        this.tmpId,
        this.amount,
        this.percentage,
      );
      this.$emit('input', request);
    },
  },
  props: {
    /**
     * @description Номер уровня.
     * @type {Number}
     */
    levelNumber: {
      required: true,
      type: Number,
    },
    /**
     * @description Значение.
     * @type {Level}
     */
    value: {
      required: true,
      type: Level,
    },
    /**
     * @description Нарушения
     * @type {Object}
     */
    violations: {
      default: () => {
      },
      type: Object,
    },
    /**
     * @description Выключен
     * @type {Boolean}
     */
    disabled: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Запретить удаление
     * @type {Boolean}
     */
    disabledDelete: {
      default: () => false,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";

.discount-card-rule {

  &__level-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--reading-color);
  }

  &__item {
    display: grid;
    grid-template-columns: minmax(100px, 200px) minmax(100px, 152px) 30px;
    gap: 15px;
  }

  &__button-close {
    @include buttons.btn-cross-remove(14px, 14px);
    margin-top: 29px;
    &:disabled {
      display: none;
    }
  }
}
</style>
